import { CloseIcon } from "@chakra-ui/icons";
import { Button, Flex, Text } from "@chakra-ui/react";
import { FunnelComponentProps } from "../../funnel/types";

export function AuthenticationHeader({
  onClose,
  text,
}: FunnelComponentProps & {
  text?: string;
}) {
  return (
    <Flex direction="row" justify="space-between" align="center" padding="16px 24px">
      <Text
        fontWeight="600"
        fontSize="20px"
        lineHeight="26px"
        fontFamily="Bricolage Grotesque"
        color="dune.dune"
      >
        {text}
      </Text>
      <Button variant="iconOnly" onClick={onClose}>
        <CloseIcon color="dune.100" />
      </Button>
    </Flex>
  );
}
